import React from 'react';
import { getCurrentUser, getUserRole, isAdmin, isEventManager } from '../services/authService';
import { Badge } from 'react-bootstrap';

const UserRoleDisplay = () => {
  const currentUser = getCurrentUser();
  const userRole = getUserRole();
  const adminStatus = isAdmin();
  const eventManagerStatus = isEventManager();

  if (!currentUser) {
    return null;
  }

  const getBadgeVariant = (role) => {
    switch (role) {
      case 'admin':
        return 'danger';
      case 'eventmanager':
        return 'warning';
      default:
        return 'secondary';
    }
  };

  return (
    <div className="d-flex align-items-center">
      <span className="me-2">Welcome, {currentUser.username}</span>
      <Badge bg={getBadgeVariant(userRole)} className="text-capitalize">
        {userRole}
      </Badge>
    </div>
  );
};

export default UserRoleDisplay;
